import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import PathsSection from "./components/PathsSection";
import BenefitsSection from "./components/BenefitsSection";
import JourneySection from "./components/JourneySection";
import CTASection from "./components/CTASection";
import BookSection from "./components/BookSection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <PathsSection />
        <BenefitsSection />
        <JourneySection />
        <CTASection />
        <BookSection />
      </main>
      <Footer />
    </div>
  );
}